import { ComponentProps } from 'react';

import Card from '../../../../../components/Card/Card';
import Inline from '../../../../../components/Inline/Inline';
import Stack from '../../../../../components/Stack/Stack';
import SubmitButton from '../../../../../components/SubmitButton/SubmitButton';
import Title from '../../../../../components/Title/Title';
import UncaughtErrors from '../../../../../components/UncaughtErrors/UncaughtErrors';
import useTrans from '../../../../../hooks/ui/useTrans';
import ValidationErrors from '../../../../../types/UI/ValidationErrors';
import FormDimmableCard from '../../../../components/FormDimmableCard/FormDimmableCard';
import BookingParameters from '../../../../types/BookingParameters';
import CannotContinueNote from '../CannotContinueNote/CannotContinueNote';
import NumberOfBoatsPicker from '../NumberOfBoatsPicker/NumberOfBoatsPicker';

type NumberOfBoatsCardProps = {
    max: number;
    parameters?: BookingParameters;
    errors?: ValidationErrors;
} & ComponentProps<typeof FormDimmableCard>;

const NumberOfBoatsCard = ({
    max,
    errors,
    parameters,
    children,
    ...cardProps
}: NumberOfBoatsCardProps) => {
    const trans = useTrans('CustomerArea.BookingForm.NumberOfBoats.');

    if (max === 0) {
        return (
            <Card {...cardProps}>
                {children}
                <CannotContinueNote>
                    {trans('NoBoatsForDate')}
                </CannotContinueNote>
            </Card>
        );
    }

    return (
        <FormDimmableCard {...cardProps}>
            {children}
            <Stack>
                <Title variant="area">{trans('PickerLabel')}</Title>
                <NumberOfBoatsPicker
                    max={max}
                    name="numberOfBoats"
                    errors={errors?.numberOfBoats}
                    defaultValue={parameters?.numberOfBoats}
                />
                <UncaughtErrors
                    errors={errors}
                    exclude={[
                        'username',
                        'password',
                        'numberOfBoats',
                        'requestedPickupDate',
                        'requestedReturnDate',
                        'couponCode',
                        'customerTypeId',
                    ]}
                />
                <Inline horizontal="right">
                    <SubmitButton size="large">
                        {trans('ButtonLabel')}
                    </SubmitButton>
                </Inline>
            </Stack>
        </FormDimmableCard>
    );
};

export default NumberOfBoatsCard;
